import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./ImageCarousel.css";

function ImageCarousel(props) {
  const { images } = props;
  const navigate = useNavigate();

  const [activeIndex, setActiveIndex] = useState(0);

  const handlePrevClick = () => {
    setActiveIndex((activeIndex - 1 + images.length) % images.length);
  };

  const handleNextClick = () => {
    setActiveIndex((activeIndex + 1) % images.length);
  };

  const handleImageClick = (productId) => {
    if (productId) {
      navigate(`/products/${productId}`);
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setActiveIndex((activeIndex + 1) % images.length);
    }, 3000);
    return () => clearTimeout(timer);
  }, [activeIndex, images.length]);

  return (
      <div className="image-carousel">
        {images.map((image, index) => (
            <div
                key={index}
                className={`carousel-item ${index === activeIndex ? "active" : ""}`}
                onClick={() => handleImageClick(image.productId)}
            >
              <div className="carousel-image-wrapper">
                <img
                    src={image.src}
                    alt={image.alt}
                    className="carousel-image"
                />
              </div>
              <div className="carousel-overlay">
                <span className="carousel-product-name">{image.alt}</span>
              </div>
            </div>
        ))}

        <button className="carousel-button prev" onClick={handlePrevClick}>
          &#10094;
        </button>
        <button className="carousel-button next" onClick={handleNextClick}>
          &#10095;
        </button>

        {/* Dots indicator */}
        <div className="carousel-dots">
          {images.map((_, index) => (
              <span
                  key={index}
                  className={`carousel-dot ${index === activeIndex ? "active" : ""}`}
                  onClick={() => setActiveIndex(index)}
              />
          ))}
        </div>
      </div>
  );
}

export default ImageCarousel;